module.exports = __webpack_public_path__ + "static/media/toelogic-2.3d4e0e99.jpg";